import Vue from 'vue'

// Might want to change it to UUID
const indexBy = 'id'

export default {
  SET (state, languages = []) {
    languages.forEach(language => {
      Vue.set(state.languages, language[indexBy], language)
    })
  },

  ADD (state, language) {
    Vue.set(state.languages, language[indexBy], language)
  },

  REMOVE (state, key) {
    Vue.delete(state.languages, key)
    if (state.active === key) {
      state.active = null
    }
  },

  SET_ACTIVE (state, key = null) {
    state.active = state.languages[key]
  },

  UPDATE (state, language) {
    state.languages[language[indexBy]] = {
      ...state.languages[language[indexBy]],
      ...language
    }
  }
}
